import { _Product_liquid, _Variant_liquid } from "./_types";
import { _Product, _Variant } from "./global-stores";

/**
 * Checks if a variant has "Default Title" as its option1 or title
 */
export const isDefaultTitle = (variant: _Variant | _Variant_liquid): boolean => {
  const option1 = (variant as any).option1;
  return option1 === "Default Title" || variant.title === "Default Title";
};

/**
 * Gets the display title for a variant.
 * If the product has only 1 variant and it's "Default Title", returns product title.
 * If the variant is "Default Title", returns product title.
 * Otherwise, returns variant title.
 */
export const getVariantDisplayTitle = (
  product: _Product | _Product_liquid,
  variant: _Variant | _Variant_liquid
): string => {
  const productVariants = (product as any).variants || [];
  
  // If product has only 1 variant and it's "Default Title", show product title only
  if (productVariants.length === 1 && isDefaultTitle(variant)) {
    return product.title;
  }
  
  // If variant is "Default Title", show product title only
  if (isDefaultTitle(variant)) {
    return product.title;
  }
  
  return variant.title;
};

